const config = {
    apiUrlBase: {
        prod: 'https://api-tree-veicular.agenciaupstairs.com.br',
        dev: 'http://localhost:8000',
    }
}

export default config;